import { actionTypes } from '../actions/fender-connect';
import { fenderConnect as defaultState } from './default.json';

export const getRedemptionCodeError = action => {
  const { error } = action || {};
  const { status, statusText } = error || {};
  const statusLabel = status || 'Error';
  const statusMsg = statusText || 'Code entered is not valid';
  return `${statusLabel}: ${statusMsg}`;
};

export const getSubStatusFromAuthResponse = action => {
  const { user } = action || {};
  const { subscriptions } = user || {};
  const { play } = subscriptions || {};
  return typeof play !== 'undefined' && (play === 'active' || play === 'pending');
};

const handlers = {
  [actionTypes.FC_REQUEST_IN_PROGRESS]: state => ({
    ...state,
    requestInProgress: true,
  }),
  [actionTypes.FC_VALIDATE_CODE_IN_PROGRESS]: state => ({
    ...state,
    validateInProgress: true,
    redemptionCodeError: null,
    redemptionCodeValid: false,
  }),
  [actionTypes.FC_SESSION_CHECK_COMPLETE]: state => ({
    ...state,
    sessionCheckComplete: true,
  }),
  [actionTypes.FC_AUTH_RESPONSE]: (state, action) => ({
    ...state,
    email: action.user.email,
    hasSubscription: getSubStatusFromAuthResponse(action),
    loggedIn: true,
    profile: action.user.profile,
    requestInProgress: false,
    sessionCheckComplete: true,
    subscriptions: action.user.subscriptions,
    userID: action.user.id,
  }),
  [actionTypes.FC_FORGOT_PASSWORD_STATUS_SUCCESS]: state => ({
    ...state,
    forgotPasswordEmailSent: true,
    requestInProgress: false,
  }),
  [actionTypes.FC_FORGOT_PASSWORD_STATUS_RESET]: state => ({
    ...state,
    forgotPasswordEmailSent: defaultState.forgotPasswordEmailSent,
  }),
  [actionTypes.FC_SIGNIN_ERROR]: (state, action) => ({
    ...state,
    errorSignIn: action.error.message,
    requestInProgress: false,
  }),
  [actionTypes.FC_CREATE_ACCOUNT_ERROR]: (state, action) => ({
    ...state,
    errorCreateAccount: action.error.message,
    requestInProgress: false,
  }),
  [actionTypes.FC_FORGOT_PASSWORD_ERROR]: (state, action) => ({
    ...state,
    errorForgotPassword: action.error.message,
    requestInProgress: false,
  }),
  [actionTypes.FC_SIGNOUT]: () => ({
    ...defaultState,
    sessionCheckComplete: true,
  }),
  [actionTypes.FC_RESET_ERROR]: state => ({
    ...state,
    errorCreateAccount: defaultState.errorCreateAccount,
    errorForgotPassword: defaultState.errorForgotPassword,
    errorSignIn: defaultState.errorSignIn,
    requestInProgress: false,
  }),
  [actionTypes.FC_LOGIN_SHOW]: state => ({
    ...state,
    loginVisible: true,
  }),
  [actionTypes.FC_LOGIN_REDIRECT]: (state, action) => ({
    ...state,
    redirect: {
      step: action.step,
      title: action.title,
      url: action.url,
    },
  }),
  [actionTypes.FC_LOGIN_HIDE]: state => ({
    ...state,
    errorCreateAccount: defaultState.errorCreateAccount,
    errorForgotPassword: defaultState.errorForgotPassword,
    errorSignIn: defaultState.errorSignIn,
    loginVisible: false,
  }),
  [actionTypes.FC_SUBSCRIBE]: state => ({
    ...state,
    hasSubscription: true,
    subscriptions: {
      ...state.subscriptions,
      play: 'active',
    },
    redemptionCodeError: null,
    requestInProgress: false,
  }),
  [actionTypes.FC_PAYMENT_METHOD_ERROR]: (state, action) => ({
    ...state,
    hasSubscription: false,
    subscriptionError: `${action.error}`,
    requestInProgress: false,
  }),
  [actionTypes.FC_REDEEM_CODE_ERROR]: (state, action) => ({
    ...state,
    redemptionCodeError: getRedemptionCodeError(action),
    requestInProgress: false,
    validateInProgress: false,
    productRatePlanSku: null,
    productRatePlans: {},
    productRatePlanId: null,
    wholesalePrice: null,
  }),
  [actionTypes.FC_VALIDATE_CODE_ERROR]: (state, action) => ({
    ...state,
    redemptionCodeError: getRedemptionCodeError(action),
    validateInProgress: false,
    productRatePlanSku: null,
    productRatePlans: {},
    productRatePlanId: null,
    wholesalePrice: null,
  }),
  [actionTypes.FC_VALIDATE_CODE_SUCCESS]: (state, action) => ({
    ...state,
    productRatePlanSku: action.response['product-rate-plan-sku'],
    productRatePlans: action.response['product-rate-plans'],
    productRatePlanId: action.response['product-rate-plan-id'],
    wholesalePrice: action.response['wholesale-price'],
    promoCodePercentage: action.response['discount-percentage'],
    requestInProgress: false,
    validateInProgress: false,
    redemptionCodeError: null,
    redemptionCodeValid: true,
  }),
  [actionTypes.FC_UPDATE_PROFILE_COMPLETE]: (state, action) => ({
    ...state,
    profile: action.userProfile,
  }),
  [actionTypes.FC_ACCOUNT_SUMMARY]: (state, action) => ({
    ...state,
    accountSummary: action.accountSummary,
  }),
  [actionTypes.FC_GET_USER_ERROR]: (state, action) => ({
    ...state,
    errorGetUser: action.error.message,
  }),
  [actionTypes.FC_GET_USER_SUCCESS]: (state, action) => ({
    ...state,
    firstName: action.response['first-name'],
    lastName: action.response['last-name'],
    email: action.response.email,
    userID: action.response.id,
  }),
  [actionTypes.FC_RESET_PASSWORD_ERROR]: (state, action) => ({
    ...state,
    errorResetPassword: action.error.message,
  }),
  [actionTypes.FC_STREAKS_TESTING_CREATED_AT]: (state, action) => ({
    ...state,
    subscriptions: {
      ...state.subscriptions,
      createdAt: action.createdAt,
    },
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
